import { StyleSheet } from "@react-pdf/renderer";

export const prepStepStyles = StyleSheet.create({
  prepStep: {
    flexDirection: "row",
    marginBottom: 8,
  },
  ingredientRow: {
    flexDirection: "row",
  },
  ingredients: {
    flexDirection: "column",
    width: "100%",
    paddingLeft: 2,
  },
  directions: {
    width: "53%",
    paddingLeft: 10,
    // marginTop: "auto",
  },
  ingredientLeft: {
    backgroundColor: "#eaeaea",
    paddingRight: 10,
    paddingLeft: 2,
    width: "15%",
  },
  ingredientRight: {
    backgroundColor: "#eaeaea",
    width: "32%",
  },
});
